__webpack_require__.p = "https://dopg8hpnitzl9.cloudfront.net/copilot-staging/assets/";